import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";

import { sendLead } from "../../utils/api";

const TextInput = ({ input, meta: { touched, error }, ...otherProps }) => {
  // meta prop contains all props for field, eg pristine, dirty, touched...
  return (
    <React.Fragment>
      <input {...otherProps} {...input} style={{ marginBottom: "5px" }} />
      <div style={{ marginBottom: "2px" }}>{touched && error}</div>
    </React.Fragment>
  );
};

const TextAreaInput = ({ input, meta: { touched, error }, ...otherProps }) => {
  // meta prop contains all props for field, eg pristine, dirty, touched...
  return (
    <React.Fragment>
      <textarea {...otherProps} {...input} style={{ marginBottom: "5px" }} />
      <div style={{ marginBottom: "2px" }}>{touched && error}</div>
    </React.Fragment>
  );
};

class MailingListForm extends Component {
  state = { disableButton: false };

  onSubmit = values => {
    this.setState({ disableButton: true });
    console.log(values);
    sendLead(values, () => this.setState({ disableButton: false }));
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <section id="contact" className="section-form">
          <div className="row">
            <div className="col-sm-12">
              <h2>We're happy to hear from you</h2>
            </div>
          </div>
          <div className="row">
            <form
              onSubmit={handleSubmit(this.onSubmit)}
              className="contact-form"
            >
              <div className="row">
                <div className="col span-1-of-3">
                  <label htmlFor="name">First Name</label>
                </div>
                <div className="col span-2-of-3">
                  <Field
                    name="first_name"
                    id="name"
                    type="text"
                    component={TextInput}
                    placeholder="Your first name"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col span-1-of-3">
                  <label htmlFor="name">Last Name</label>
                </div>
                <div className="col span-2-of-3">
                  <Field
                    name="last_name"
                    id="name"
                    type="text"
                    component={TextInput}
                    placeholder="Your last name"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col span-1-of-3">
                  <label htmlFor="email">Email</label>
                </div>
                <div className="col span-2-of-3">
                  <Field
                    name="email"
                    id="email"
                    type="email"
                    component={TextInput}
                    placeholder="Your email"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col span-1-of-3">
                  <label htmlFor="find-us">How did you find us?</label>
                </div>
                <div className="col span-2-of-3">
                  <Field name="source" id="find-us" component="select">
                    <option value="friends">Friends</option>
                    <option value="search">Search engine</option>
                    <option value="ad">Advertisement</option>
                    <option value="other">Other</option>
                  </Field>
                </div>
              </div>

              <div className="row">
                <div className="col span-1-of-3">
                  <label>Newsletter?</label>
                </div>
                <div className="col span-2-of-3">
                  <Field
                    type="checkbox"
                    name="news"
                    id="news"
                    component="input"
                  />
                  Yes, Please
                </div>
              </div>

              <div className="row">
                <div className="col span-1-of-3">
                  <label>Drop us a line</label>
                </div>
                <div className="col span-2-of-3">
                  <Field
                    name="comment"
                    placeholder="Your message"
                    component={TextAreaInput}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col span-1-of-3">
                  <label>&nbsp;</label>
                </div>
                <div className="col span-2-of-3">
                  <input
                    type="submit"
                    value="Send it!"
                    disabled={this.state.disableButton}
                  />
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.first_name) {
    errors.first_name = "Required";
  }
  if (!values.last_name) {
    errors.last_name = "Required";
  }
  if (!values.email) {
    errors.email = "Required";
  }
  if (!values.comment) {
    errors.comment = "Required";
  }
  return errors;
};

export default reduxForm({
  validate,
  form: "mailingListForm",
  initialValues: { source: "friends", news: true }
})(MailingListForm);
